import { call, put, takeLatest } from 'redux-saga/effects'
import { getMantenimiento } from './mantenimientoApi'
import { setMantenimientoInfo } from './mantenimientoSlice'

function* loadMantenimientoSaga() {
  try {
    const response: ReturnType<typeof getMantenimiento> = yield call(
      getMantenimiento
    )
    if (response && response[0]) {
      const { activo, fecha_inicio, fecha_fin } = response[0]
      yield put(setMantenimientoInfo({ activo, fecha_inicio, fecha_fin }))
    }
  } catch (error) {
    console.error('Error fetching mantenimiento:', error)
  }
}

export default function* watchMantenimientoSaga() {
  yield takeLatest('MANTENIMIENTO::LOAD', loadMantenimientoSaga)
}
